class AES256_CBC {

    static genkeys() {

        return new Promise( (resolve, reject) => {

            window.crypto.subtle.generateKey(
                {
                    name: "AES-CBC",
                    length: 256,
                },
                true,
                ["encrypt", "decrypt"]
            ).then( (key) => {

                if ( key ) {

                    resolve({
                        iv: window.crypto.getRandomValues(new Uint8Array(16)),
                        key
                    });
                }
                else { reject(); }

            }).catch(reject);
        });
    }

    static exportKey(key) {

        return new Promise( (resolve, reject) => {

            if ( key ) {

                window.crypto.subtle.exportKey(
                    'raw',
                    key
                ).then( ( exported_key ) => {
                    resolve(new Uint8Array(exported_key));
                }).catch(reject);

            }
            else { reject(); }
        });
    }

    static importKey(key) {

        return new Promise( (resolve, reject) => {

            if ( key ) {

                window.crypto.subtle.importKey(
                    "raw",
                    key,
                    {
                        name: "AES-CBC",
                    },
                    true,
                    ["encrypt", "decrypt"]
                ).then(resolve).catch(reject);
            }
            else { reject(); }
        });
    }

    static encrypt(data, key, iv) {

        return new Promise( (resolve, reject) => {

            if ( data && key && iv ) {

                if ( typeof data == "string" ) {
                    data = new TextEncoder('utf-8').encode(data);
                }

                window.crypto.subtle.encrypt(
                   {
                       name: "AES-CBC",
                       iv: iv,
                   },
                   key,
                   data
               ).then( (encrypted) => {
                   resolve(new Uint8Array(encrypted));
               }).catch(reject);

            }
            else { reject(); }
        });
    }

    static decrypt(encrypted, key, iv) {

        return new Promise( (resolve, reject) => {

            if ( encrypted && key && iv ) {

                window.crypto.subtle.decrypt(
                    {
                        name: "AES-CBC",
                        iv: iv,
                    },
                    key,
                    encrypted
                ).then( (decrypted) => {
                    resolve(new Uint8Array(decrypted));
                }).catch(reject);

            }
            else { reject(); }

        });
    }

}

export default AES256_CBC;
